// These must match the Color ID 'ID' column in Airtable.
const status_decoration_lookup = {
  'Allies': {
    class: 'pro',
    icon: '#icon-allies'
  },
  'Favorable': {
    class: 'complicated-pro',
    icon: '#icon-favorable'
  },
  'Complicated': {
    class: 'complicated',
    icon: '#icon-complicated'
  },
  'Unfavorable': {
    class: 'complicated-con',
    icon: '#icon-unfavorable'
  },
  'Adversaries': {
    class: 'con',
    icon: '#icon-adversaries'
  },
  'No Relationship of Note': {
    class: 'na',
    icon: '#icon-na'
  }
}

let statuses = null;
export const initStatuses = async () => {
  const res = await fetch('data/statuses.json');
  const status_lookup = await res.json();
  statuses = {};
  Object.keys(status_decoration_lookup).forEach((key) => {
    const status = status_lookup.filter((item) => item.key == key)[0];
    if (status) {
      const lookup = status_decoration_lookup[key];
      statuses[status.id] = {
        key: key,
        label: status.label,
        icon: lookup.icon,
        class: lookup.class,
      };
    }
  });
  return statuses;
};

const getProp = (rel, prop) => {
  if (rel in statuses) {
    return statuses[rel][prop];
  }
  const status_keys = getStatusKeys();
  return statuses[status_keys[status_keys.length - 1]];
}

export function getRelationshipLabel(rel) { return getProp(rel, 'label'); };
export function getRelationshipIcon(rel) { return getProp(rel, 'icon'); };
export function getRelationshipColor(rel) { return getProp(rel, 'class'); };
export function getStatusKeys() { return (statuses ? Object.keys(statuses) : []); };